import React, { useState, useContext } from 'react'
import './override.css'
import { ControlsContext } from '../../providers/controlsProvider'
import { Popup } from '../Popup'
import { Box, Text } from '../../designSystem'
import EmptyAlerts from '../Images/EmptyAlerts'
import {
    head,
    innerContent,
    title,
    bottomBGSection,
    BackBtn,
    emptyState,
    noResultsText,
    noResultsSubtext
} from './style'
import NotificationsUI from '../../pages/Notifications/Notifications.UI'
import { isMobileOrTablet } from '../../pages/Home/helpers'
import { NotificationsContext } from '../../providers/notificationsProvider'

const Alerts = () => {
    const { isAlertsShown, toggleIsAlertsShown } = useContext(ControlsContext)
    const { notificationArr, chapterNotificationArr } = useContext(NotificationsContext)
    const [popupRef, setPopupRef] = useState(null);
    return (
        <Popup
            show={isAlertsShown}
            setPopupRef={setPopupRef}
            close={() =>  toggleIsAlertsShown(false)}
            className="right-drawer-alerts"
            renderCloseButton={() => !isMobileOrTablet() && <div className="close-button-alerts" onClick={() =>  toggleIsAlertsShown(false)}>˟</div>}
        >
            <Box {...head}>
                <Box {...innerContent}>
                    <Box display="flex" flexDirection="row">{isMobileOrTablet() && <BackBtn onClick={() =>  toggleIsAlertsShown(false)}/>} <Text {...title}>Notifications</Text></Box>
                    {notificationArr.length > 0 || chapterNotificationArr?.length > 0  ? <NotificationsUI /> : 
                        <Box {...emptyState}>
                            <EmptyAlerts/>
                            <Text {...noResultsText}>No Notifications yet</Text>
                            <Text {...noResultsSubtext}>
                                You're all caught up with all the notifications.
                            </Text>
                        </Box>
                    }
                </Box>
                <Box {...bottomBGSection} />
            </Box>
        </Popup>
    )
}

export default Alerts